import * as React from 'react';
import { useRef, useEffect } from 'react';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import Link from '@src/components/link';

import { start } from '@src/utils/x-ani';
import { X_ANI_CONFIG } from './animation';
import TemplateBox, { FunctionSlot, SloganSlot } from '@src/business-components/kv-screen-template';

const styles = require('./index.less');

export default wrapStore(({ store, isActive }) => {
  store.use();
  const ctxRef = useRef(null);

  useEffect(
    () => {
      if (!ctxRef.current) {
        ctxRef.current = start(X_ANI_CONFIG, '#kvSection');
      } else {
        if (isActive) {
          ctxRef.current.restart();
        } else {
          ctxRef.current.reverse();
        }
      }
    },
    [isActive]
  );

  return (
    <section id="kvSection" className={styles.kvSectionRoot} style={{ backgroundImage: `url(${store?.kvInfo?.kv})` }}>
      {store?.kvInfo?.template && (
        <TemplateBox type={store?.kvInfo?.template}>
          <SloganSlot />
          <FunctionSlot>
            <Link className={styles.btnDownload} onClick={store.onDownloadClick} />
          </FunctionSlot>
        </TemplateBox>
      )}
      {/* 适龄提示 */}
      <div data-x-ani-label="ageAppropriateTips" className={styles.ageAppropriateTips}>
        <AgeAppropriateTips gameName={'剑侠世界4'} />
      </div>
      {/*<Link className={styles.btnDownload} onClick={store.onDownloadClick} />*/}
    </section>
  );
}, Store);
